var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProductHighlightsIndica = function SvgIconProductHighlightsIndica(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#244D5A",
    d: "M7.917 1.956A.8.8 0 0 1 8 2.849a7.5 7.5 0 0 0-.915 3.604c0 4.189 3.415 7.58 7.623 7.58q.826-.001 1.597-.166a.82.82 0 0 1 .844.33.764.764 0 0 1-.032.93 8.7 8.7 0 0 1-6.759 3.206c-4.802 0-8.691-3.87-8.691-8.636 0-3.587 2.202-6.664 5.337-7.969a.78.78 0 0 1 .913.228m-1.19 1.076a7.57 7.57 0 0 0-3.993 6.665c0 4.188 3.416 7.58 7.624 7.58a7.62 7.62 0 0 0 5.422-2.253 9 9 0 0 1-1.072.066c-4.802 0-8.69-3.869-8.69-8.636a8.55 8.55 0 0 1 .71-3.422"
  })));
};
export default SvgIconProductHighlightsIndica;